import ChangeListingTierModal from './ChangeListingTierModal.component';

export default ChangeListingTierModal;
